"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components2 = require("./components");

var _useKeyboard = _interopRequireDefault(require("./hooks/useKeyboard"));

var _props = require("./props");

var _store = require("./store");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AspectRatioBox = (0, _styledComponents["default"])(_widgets.Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    aspect-ratio: ", ";\n"])), function (props) {
  return props.aspectRatio;
});

var Component = function Component(_ref) {
  var aspectRatioFromProps = _ref.aspectRatio,
      slidesWrapper = _ref.slidesWrapper,
      showArrows = _ref.showArrows,
      showDots = _ref.showDots,
      showHead = _ref.showHead,
      showText = _ref.showText,
      showLink = _ref.showLink,
      props = _objectWithoutProperties(_ref, ["aspectRatio", "slidesWrapper", "showArrows", "showDots", "showHead", "showText", "showLink"]);

  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
      override = _useOverrides.override,
      rest = _useOverrides.rest;

  var sliderRef = (0, _react.useRef)(null);
  var slidesRef = (0, _react.useRef)(null);

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state;
  }),
      slidesNumb = _useSelector.slidesNumb,
      slidesList = _useSelector.slidesList,
      animDuration = _useSelector.animDuration,
      animFunction = _useSelector.animFunction,
      active = _useSelector.active,
      position = _useSelector.position,
      animate = _useSelector.animate;

  var dispatch = (0, _reactRedux.useDispatch)();
  var clickNumb = (0, _react.useCallback)(function (newActive) {
    return dispatch({
      type: 'CLICK_NUMB',
      active: newActive
    });
  }, [dispatch]);
  var onClickPrev = (0, _react.useCallback)(function () {
    dispatch((0, _store.clickPrev)());
  }, [dispatch]);
  var onClickNext = (0, _react.useCallback)(function () {
    dispatch((0, _store.clickNext)());
  }, [dispatch]);
  (0, _useKeyboard["default"])(sliderRef, onClickNext, onClickPrev);
  var aspectRatio = (0, _react.useMemo)(function () {
    return aspectRatioFromProps !== 'auto' ? aspectRatioFromProps.replace(':', '/') : aspectRatioFromProps;
  }, [aspectRatioFromProps]);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    ref: sliderRef,
    position: "relative",
    "align-self": "normal",
    overflow: "hidden"
  }, rest), /*#__PURE__*/_react["default"].createElement(AspectRatioBox, _extends({
    ref: slidesRef
  }, override('Slides'), {
    transform: "translateX(-".concat(position, "%)"),
    transition: animate ? "transform ".concat(animDuration, "ms ").concat(animFunction) : 'none',
    aspectRatio: aspectRatio
  }), slidesList.map(function (numb, index) {
    return /*#__PURE__*/_react["default"].createElement(_components2.Slide, {
      key: "".concat(rest['data-qid'], "-slide-").concat(numb, "-").concat(index) // eslint-disable-line
      ,
      index: index,
      slides: slidesNumb,
      slidesWrapper: slidesWrapper,
      numb: numb,
      showHead: showHead,
      showText: showText,
      showLink: showLink,
      override: override
    });
  })), showArrows && /*#__PURE__*/_react["default"].createElement(_widgets.Box, override('Arrows'), /*#__PURE__*/_react["default"].createElement(_components2.Arrow, {
    type: "Prev",
    clickFunc: onClickPrev,
    override: override
  }), /*#__PURE__*/_react["default"].createElement(_components2.Arrow, {
    type: "Next",
    clickFunc: onClickNext,
    override: override
  })), showDots && /*#__PURE__*/_react["default"].createElement(_widgets.Box, override('Points'), slidesList.slice(1, -1).map(function (numb, index) {
    return /*#__PURE__*/_react["default"].createElement(_components2.Point, {
      key: "point-".concat(numb, "-").concat(index) // eslint-disable-line
      ,
      numb: numb,
      active: active,
      clickFunc: clickNumb,
      override: override
    });
  })));
};

var _default = Component;
exports["default"] = _default;